import { render, staticRenderFns } from "./PublicReportCategories.vue?vue&type=template&id=0c38ae4a&scoped=true"
import script from "./PublicReportCategories.vue?vue&type=script&lang=js"
export * from "./PublicReportCategories.vue?vue&type=script&lang=js"
import style0 from "./PublicReportCategories.vue?vue&type=style&index=0&id=0c38ae4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38ae4a",
  null
  
)

export default component.exports